export const GET_TOGGLE_SETTINGS_REQUEST = 'GET_TOGGLE_SETTINGS_REQUEST';
export const GET_TOGGLE_SETTINGS_SUCCESS = 'GET_TOGGLE_SETTINGS_SUCCESS';
export const GET_TOGGLE_SETTINGS_FAIL = 'GET_TOGGLE_SETTINGS_FAIL';

export const UPDATE_TOGGLE_SETTINGS_REQUEST = 'UPDATE_TOGGLE_SETTINGS_REQUEST';
export const UPDATE_TOGGLE_SETTINGS_SUCCESS = 'UPDATE_TOGGLE_SETTINGS_SUCCESS';
export const UPDATE_TOGGLE_SETTINGS_FAIL = 'UPDATE_TOGGLE_SETTINGS_FAIL';
export const CLEAR_UPDATE_TOGGLE_SETTINGS = 'CLEAR_UPDATE_TOGGLE_SETTINGS';

// =============================NOTIFICATION TYPES============================================

// gettings notifications settings
export const GET_NOTIFICATION_SETTINGS_REQUEST =
  'GET_NOTIFICATION_SETTINGS_REQUEST';
export const GET_NOTIFICATION_SETTINGS_SUCCESS =
  'GET_NOTIFICATION_SETTINGS_SUCCESS';
export const GET_NOTIFICATION_SETTINGS_FAIL = 'GET_NOTIFICATION_SETTINGS_FAIL';

// Get selected user settings
export const GET_USER_NOTIFICATIONS_REQUEST = 'GET_USER_NOTIFICATIONS_REQUEST';
export const GET_USER_NOTIFICATIONS_SUCCESS = 'GET_USER_NOTIFICATIONS_SUCCESS';
export const GET_USER_NOTIFICATIONS_FAIL = 'GET_USER_NOTIFICATIONS_FAIL';

// set user settings
export const SET_USER_NOTIFICATION_SETTINGS_REQUEST =
  'SET_USER_NOTIFICATION_SETTINGS_REQUEST';
export const SET_USER_NOTIFICATION_SETTINGS_SUCCESS =
  'SET_USER_NOTIFICATION_SETTINGS_SUCCESS';
export const SET_USER_NOTIFICATION_SETTINGS_FAIL =
  'SET_USER_NOTIFICATION_SETTINGS_FAIL';

// reading notification
export const READ_NOTIFICATIONS_REQUEST = 'READ_NOTIFICATIONS_REQUEST';
export const READ_NOTIFICATIONS_SUCCESS = 'READ_NOTIFICATIONS_SUCCESS';
export const READ_NOTIFICATIONS_FAIL = 'READ_NOTIFICATIONS_FAIL';

// view notification
export const VIEW_NOTIFICATION_REQUEST = 'VIEW_NOTIFICATION_REQUEST';
export const VIEW_NOTIFICATION_SUCCESS = 'VIEW_NOTIFICATION_SUCCESS';
export const VIEW_NOTIFICATION_FAIL = 'VIEW_NOTIFICATION_FAIL';

// clear notifications
export const CLEAR_NOTIFICATION_REQUEST = 'CLEAR_NOTIFICATION_REQUEST';
export const CLEAR_NOTIFICATION_SUCCESS = 'CLEAR_NOTIFICATION_SUCCESS';
export const CLEAR_NOTIFICATION_FAIL = 'CLEAR_NOTIFICATION_FAIL';

// after deleting notifications update redux state
export const UPDATE_NOTIFICATIONS_LIST = 'UPDATE_NOTIFICATIONS_LIST';

// CLEARING SET NOTIFICATION STATE
export const CLEAR_SET_NOTIFICATION_STATES = 'CLEAR_SET_NOTIFICATION_STATES';

// =============================PRICING MATRIX TYPES============================================

// get all matrixes
export const GET_MATRIXES_REQUEST = 'GET_MATRIXES_REQUEST';
export const GET_MATRIXES_SUCCESS = 'GET_MATRIXES_SUCCESS';
export const GET_MATRIXES_FAIL = 'GET_MATRIXES_FAIL';

// add new matrix
export const ADD_MATRIX_REQUEST = 'ADD_MATRIX_REQUEST';
export const ADD_MATRIX_SUCCESS = 'ADD_MATRIX_SUCCESS';
export const ADD_MATRIX_FAIL = 'ADD_MATRIX_FAIL';

// update matrix
export const UPDATE_MATRIX_REQUEST = 'UPDATE_MATRIX_REQUEST';
export const UPDATE_MATRIX_SUCCESS = 'UPDATE_MATRIX_SUCCESS';
export const UPDATE_MATRIX_FAIL = 'UPDATE_MATRIX_FAIL';

// delete matrix
export const DELETE_MATRIX_REQUEST = 'DELETE_MATRIX_REQUEST';
export const DELETE_MATRIX_SUCCESS = 'DELETE_MATRIX_SUCCESS';
export const DELETE_MATRIX_FAIL = 'DELETE_MATRIX_FAIL';

// clear matrix state
export const CLEAR_MATRIX_STATE = 'CLEAR_MATRIX_STATE';
